<template>
	<v-tooltip :disabled="!isBeeIcon" bottom  >
		<template v-slot:activator="slotData">
			<!--
				لنقل
				[click event](https://vuetifyjs.com/en/components/buttons/#api-events)
				من v-btn إلى bee-btn 
				@event click
			-->
			<v-btn
				v-show="hidden ? false : true"
				:disabled="disabledValue"
				class="white--text"
				@click="$emit('click')"
				:outlined="outlined"
				:class="isBeeIcon? `beeicon ${localouterClass}`: `beebtn ${localouterClass}`"
				:href="href"
				:target="target"
				:small="isBeeIcon"
				:depressed="isBeeIcon || depressed"
				:loading="loading"
				v-bind="isBeeIcon ? slotData.attr : v_bind"
				v-on="isBeeIcon ? slotData.on : v_on"
				:color="isBeeIcon? (type ? (LstColor.find((c) => c.type == type)?LstColor.find((c) => c.type == type).color :'') : ''):color"
			>
				<v-icon :color="iconColor ? iconColor : 'white'" :small="icon.includes('fa')" v-if="icon">{{ icon }}</v-icon>
				<v-icon :color="iconColor ? iconColor : 'white'" v-else-if="type"  small>{{ LstColor.find((c) => c.type == type)? LstColor.find((c) => c.type == type).icon:'' }}</v-icon>
				<span v-if="content" :class="{'ps-1': icon}"> {{ content }} </span>
				<!--
					@slot تحديد محتوى الزر بالـ slot بدلاً من الـ content prop
				-->
				<slot name="content"></slot>
			</v-btn>
		</template>
		<span>{{tooltip ? tooltip : (LstColor.find((c) => c.type == type)? LstColor.find((c) => c.type == type).tooltip : '') }}</span>
	</v-tooltip>
</template>
<script>

//enable dynamic-imports
import baseBeeComponent from "../../baseBeeComponent";
import { LstColor_beeBtnIcon } from "../../../../settings/constants/beeBtnIconKinds"
/**
 * @displayName bee-btn
 * 
 * @example ../../../../../docs/components/beeBtn.md
 */
export default {
	mixins: [baseBeeComponent],
	props: {
		/**
		 * تستخدم عندما تريد أن يحوي الزر أيقونة فقط يمكن أن تستخدم مع `type` أو `icon` , `iconColor`
		 */
		beeicon: {},
		
		/** @ignore */
		disabled: {},

		/** تستخدم لتحديد النص داخل الزر وقيتها لا تؤثر عندما `beeicon` تكون فعالة */
		content: {},

		/** تخصيص الأيقونة التي تظهر داخل الزر بغض النظر عن الأيقونة الافتراضية للـ `type` */
		icon: {},

		/** تخصيص لون الزر بغض النظر عن اللون الافتراضي للـ `type` */
		color: {},
		
		/** تستخدم لترير الـ bind من الـ component الحاوي للزر - *كما في حالة الـ tooltip* */
		v_bind: {},

		/** تستخدم لترير الـ on من الـ component الحاوي للزر - *كما في حالة الـ tooltip* */
		v_on: {},

		/** لتفعيل الـ loading للزر */
		loading: {},

		/** جعل الزر يشير route ينقل إليه عند نقره - *مهملة* */
		href: {},

		/** جعل الزر يشير route ينقل إليه عند نقره - *مهملة* */
		target: {},

		/** تحديد الـ css class التي تطبق على الزر */
		outerClass: {},

		/**
		 * تحديد نوع الزر لاختيار الأيقونة واللون الافتراضيين وتحتاج إلى الـ **beeicon**
		 * 
		 * @values change-status, add, edit, delete, show, save, cancel, enter, up, down, settings
		 */
		type: {}, //beeicon

		/** تخصيص محتوى الـ tooltip بغض النظر عن الـ `type` */
		tooltip: {}, //beeicon

		/** جعل الزر بإطار خارجي فقط */
		outlined: {},

		/** تخفيض حجم الزر */
		depressed: {},

		/** أخفاء أو إظهار الزر*/
		hidden: {},

		/** تخصيص لون الأيقونة */
		iconColor: {}
	},
	data() {
		return {
			isBeeIcon:false,
			slotData:{},
		};
	},
	computed:{
		localouterClass(){
			return this.outerClass ? this.outerClass : ''
		},

		LstColor(){
			return [
				{
					type: "change-status",
					color: 'black',
					icon: "fas fa-circle-notch",
					tooltip: this.$t('change-state') //, تغيير الحالة"
				},
				{
					type: "add",
					color: this.$vuetify.theme.themes.light.addingColor,
					icon: "fa-plus",
					tooltip: this.$t('add'), //"إضافة"
				},
				{
					type: "edit",
					color: this.$vuetify.theme.themes.light.editingColor,
					icon: "fa-edit",
					tooltip: this.$t('edit'), //"تعديل"
				},
				{
					type: "delete",
					color: this.$vuetify.theme.themes.light.deletingColor,
					icon: "fa-trash-alt",
					tooltip: this.$t('delete'), //"حذف"
				},
				{
					type: "show",
					color: this.$vuetify.theme.themes.light.displayingColor,
					icon: "fa-eye",
					tooltip: this.$t('show'), //"عرض"
				},
				{
					type: "save",
					color: this.$vuetify.theme.themes.light.blueGray,
					icon: "fa-save",
					tooltip: this.$t('save'), //"حفظ",
				},
				{
					type: "cancel",
					color: this.$vuetify.theme.themes.light.deletingColor,
					icon: "fa-ban",
					tooltip: this.$t('cancel'), //"إلغاء",
				},
				{
					type: "enter",
					color: this.$vuetify.theme.themes.light.displayingColor,
					icon: "fa-arrow-circle-right",
					tooltip: this.$t('browse'), //"استعراض"
				},
				{
					type: "up",
					color: this.$vuetify.theme.themes.light.displayingColor,
					icon: "fa fa-arrow-circle-up",
					tooltip: this.$t('previous'), //"السابق"
				},
				{
					type: "down",
					color: this.$vuetify.theme.themes.light.displayingColor,
					icon: "fa fa-arrow-circle-down",
					tooltip: this.$t('next'), //"التالي",
				},
				{
					type: "settings",
					color: this.$vuetify.theme.themes.light.unactive,
					icon: "fa-cogs",
					tooltip: this.$t('manage'), //"إدارة"
				},

				...LstColor_beeBtnIcon
			]
		}
	},
	methods: {
		warningUse() {
			if (this.type || this.tooltip) {
				if(!this.isBeeIcon)
				console.warn(
					"[BeeBtn] attribute such as type & tooltip will not affect... use beeicon attr to enable it"
				);
			}
		},
	},
	mounted:async function() {
		this.isBeeIcon = (typeof this.beeicon === 'string' ? true : false || this.beeicon);
		if (!this.isBeeIcon)
		{
			this.slotData.on=this.v_on;
			this.slotData.attr=this.v_bind;
		}
		this.warningUse();
	},

	i18n: {
		messages: {
			ar: {
				'change-state': 'تغيير الحالة',
				add: 'إضافة',
				edit: 'تعديل',
				delete: 'حذف',
				show: 'عرض',
				save: 'حفظ', 
				cancel: 'إلغاء', 
				browse: 'استعراض',
				previous: 'السابق',
				next: 'التالي',
				manage: 'إدارة' 
			},

			en: {
				'change-state': 'change status',
				add: 'add',
				edit: 'edit',
				delete: 'delete',
				show: 'show',
				save: 'save', 
				cancel: 'cancel', 
				browse: 'browse',
				previous: 'previous',
				next: 'next',
				manage: 'manage' 
			},

			es: {
				'change-state': 'cambiar estado',
				add: 'añadir',
				edit: 'editar',
				delete: 'eliminar',
				show: 'mostrar',
				save: 'guardar',
				cancel: 'cancelar',
				browse: 'navegar',
				previous: 'anterior',
				next: 'próximo',
				manage: 'gestionar',
			},

		}
	}
};
/* eslint-enable */
</script>
<style>
.v-btn:not(.v-btn--round).v-size--small {
	padding: 0 !important;
	height: 34px !important;
	min-width: 41px !important;
}
button.v-btn.v-btn--depressed.theme--dark.v-size--default.transparent:before {
	background-color: transparent;
}
button.v-btn.v-btn--depressed.theme--dark.v-size--default.transparent:hover {
	background-color: rgba(255, 255, 255, 0.2) !important;
}
</style>
